var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrintNoOk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 113.972,
    height: 128,
    viewBox: "0 0 113.972 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2556",
    "data-name": "Grupo 2556",
    transform: "translate(-550.695 -143)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "fingerprint-black-48dp",
    transform: "translate(550.695 143)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_38",
    "data-name": "Trazado 38",
    d: "M0,0H57.293V61H0Z",
    transform: "translate(23.663 27.628)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_39",
    "data-name": "Trazado 39",
    d: "M89.1,16.358a2.7,2.7,0,0,1-1.337-.349c-11.161-5.755-20.81-8.2-32.378-8.2a66.5,66.5,0,0,0-32.378,8.2,2.913,2.913,0,1,1-2.79-5.115A72.989,72.989,0,0,1,55.389,2C67.77,2,78.582,4.732,90.44,10.836A2.942,2.942,0,0,1,89.1,16.358ZM5.922,46.875a3.029,3.029,0,0,1-1.686-.523,2.9,2.9,0,0,1-.7-4.069,60.1,60.1,0,0,1,21.8-19.008,67.1,67.1,0,0,1,59.93-.058,60.327,60.327,0,0,1,21.8,18.892A2.919,2.919,0,0,1,102.3,45.48,54.57,54.57,0,0,0,82.593,28.39a61.252,61.252,0,0,0-54.641.058A55.144,55.144,0,0,0,8.189,45.654a2.534,2.534,0,0,1-2.267,1.221Zm36.33,70.161a2.727,2.727,0,0,1-2.034-.872,58.763,58.763,0,0,1-11.684-15.346,51.6,51.6,0,0,1-6.1-25.228c0-17.264,14.765-31.331,32.9-31.331s32.9,14.067,32.9,31.331a2.906,2.906,0,0,1-5.813,0c0-14.067-12.149-25.518-27.088-25.518S28.243,61.524,28.243,75.591A45.539,45.539,0,0,0,33.649,97.97,55.021,55.021,0,0,0,44.4,112.037a2.985,2.985,0,0,1,0,4.127,3.188,3.188,0,0,1-2.151.872ZM83.93,106.282a31.3,31.3,0,0,1-18.02-5.173A30.949,30.949,0,0,1,52.076,75.591a2.906,2.906,0,0,1,5.813,0A25,25,0,0,0,69.165,96.284a25.488,25.488,0,0,0,14.765,4.127,38.415,38.415,0,0,0,6.045-.581,2.919,2.919,0,1,1,.988,5.755A39.7,39.7,0,0,1,83.93,106.282ZM72.246,118.257a3.4,3.4,0,0,1-.756-.116c-9.242-2.558-15.288-5.987-21.624-12.207A42.414,42.414,0,0,1,37.253,75.591c0-9.417,8.022-17.09,17.9-17.09s17.9,7.673,17.9,17.09c0,6.22,5.406,11.277,12.091,11.277S97.241,81.81,97.241,75.591c0-21.914-18.892-39.7-42.143-39.7-16.508,0-31.622,9.184-38.423,23.426a37.394,37.394,0,0,0-3.43,16.276A57.765,57.765,0,0,0,17.14,96.575a2.837,2.837,0,0,1-1.686,3.72,2.883,2.883,0,0,1-3.72-1.686A64.759,64.759,0,0,1,7.491,75.591a43.67,43.67,0,0,1,3.953-18.834C19.175,40.539,36.323,30.018,55.1,30.018c26.448,0,47.956,20.4,47.956,45.515,0,9.417-8.022,17.09-17.9,17.09s-17.9-7.673-17.9-17.09c0-6.22-5.406-11.277-12.091-11.277S43.066,69.313,43.066,75.532a36.606,36.606,0,0,0,10.87,26.216c5.522,5.464,10.812,8.487,19.008,10.754a2.885,2.885,0,0,1,2.034,3.546,2.836,2.836,0,0,1-2.732,2.209Z",
    transform: "translate(-2.997 -2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2553",
    "data-name": "Grupo 2553",
    transform: "translate(369 -533.667)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2009",
    "data-name": "Grupo 2009",
    transform: "translate(258 767)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1078",
    "data-name": "Grupo 1078",
    transform: "translate(0 37.667) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4433",
    "data-name": "Trazado 4433",
    d: "M18.833,0A18.833,18.833,0,1,1,0,18.833,18.833,18.833,0,0,1,18.833,0Z",
    transform: "translate(0 0)",
    fill: "#dc3545"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ico_record",
    "data-name": "ico/record",
    transform: "translate(3 3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4276",
    "data-name": "Trazado 4276",
    d: "M0,0H32.286V32.286H0Z",
    fill: "none",
    opacity: 0.24
  }))), /*#__PURE__*/React.createElement("g", {
    id: "close_black_24dp",
    transform: "translate(3.363 3.363)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7935",
    "data-name": "Trazado 7935",
    d: "M0,0H31.613V31.613H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7936",
    "data-name": "Trazado 7936",
    d: "M23.441,6.857,21.584,5l-7.363,7.363L6.857,5,5,6.857l7.363,7.363L5,21.584l1.857,1.857,7.363-7.363,7.363,7.363,1.857-1.857-7.363-7.363Z",
    transform: "translate(1.586 1.586)",
    fill: "#fff"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrintNoOk);
export default __webpack_public_path__ + "static/media/printNoOk.4f31c0ab7d44a0b78b0c226dc06da983.svg";
export { ForwardRef as ReactComponent };